import { useQuery } from "@tanstack/react-query";
import { qoStudentCurriculum } from "../../utils/queryOptions";
import RoadmapHero from "./RoadmapHero";
import RoadmapPath from "./RoadmapPath";
import RoadmapEndTrophy from "./RoadmapEndTrophy";

export default function CurriculumRoadmap() {
  const { data, isLoading, isError, refetch } = useQuery(qoStudentCurriculum());

  if (isLoading) {
    return (
      <div className="space-y-3">
        <div className="bg-white/5 rounded-2xl h-24 animate-pulse" />
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="bg-white/5 rounded-2xl h-20 animate-pulse" />
        ))}
      </div>
    );
  }

  if (isError || !data) {
    return (
      <div className="text-center text-white/60 py-10">
        <p>Müfredat yüklenemedi.</p>
        <button
          onClick={() => refetch()}
          className="mt-3 px-4 py-2 rounded-lg bg-white/10 hover:bg-white/20 text-sm"
        >
          Tekrar dene
        </button>
      </div>
    );
  }

  return (
    <>
      <RoadmapHero program={data.program} />
      <div className="box rounded-3xl overflow-hidden">
        <div className="p-4 sm:p-6">
          <RoadmapPath modules={data.modules} />
          <RoadmapEndTrophy modules={data.modules} />
        </div>
      </div>
    </>
  );
}
